import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toArray',
})
export class ToArrayPipe implements PipeTransform {
  transform(value: any | any[]): any[] {
    if (typeof value === 'object') {
      return value;
    } else {
      return [value];
    }
  }
}

@Pipe({
  name: 'castToNumber',
})
export class CastToNumberPipe implements PipeTransform {
  /**
   * use this pipe when your variable is an union type, but you know for sure it will be a number
   */
  transform(value: any): number {
    return value;
  }
}

@Pipe({
  name: 'castToString',
})
export class CastToStringPipe implements PipeTransform {
  /**
   * use this pipe when your variable is an union type, but you know for sure it will be a string
   */
  transform(value: any): string {
    return value;
  }
}
